export const GAME_COMPLETED_EVENT = 'GAME_COMPLETED' as const;
